import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, of, tap } from 'rxjs';
import { enviroment } from 'src/environments/environment';
import { LanguageEnum } from '../model/enum/language-enum';
import { SharingProjectType } from '../model/sharingProjectType';
import { SharingProjectTypeResponse } from '../model/response/sharingProjectType-response';
import { Item } from '../model/Item';

@Injectable({providedIn: 'root'})
export class SharingProjectTypeService {

  httpOptions: {};
  sharingProjectTypeUrl: string;

  constructor(private http: HttpClient) {
    
  let idToken = sessionStorage.getItem('idToken') || ""
    this.httpOptions = {
      headers: new HttpHeaders({  
        'Content-Type': 'sharingProjectType/json; charset=utf-8',
        'Authorization': `Bearer ${idToken}`
      })
    };
    this.sharingProjectTypeUrl = enviroment.BASE_URL_API + '/global/sharing_project_type';
  }

  getAllSharingProjectType() : Observable<SharingProjectTypeResponse[]> {
    let lang = this.getLanguage(sessionStorage.getItem('language'));
    let idToken = sessionStorage.getItem('idToken');
    let url = this.sharingProjectTypeUrl + this.getLanguageUrl(lang);
    
    return this.http.get<SharingProjectTypeResponse[]>(url, this.httpOptions).pipe(tap());
  }

  toSharingProjectType(sharingProjectType: SharingProjectTypeResponse) : SharingProjectType {
    if(sharingProjectType) {
      return new SharingProjectType(
        sharingProjectType.sharingProjectTypeId,
        sharingProjectType.internationalizationId,
        sharingProjectType.sharingProjectTypeDescription,
            new Date(sharingProjectType.sharingProjectTypeCreatedDate));
    } else {
      return new SharingProjectType();
    }
  }

  toSharingProjectTypeList(ctrs: SharingProjectTypeResponse[]) : SharingProjectType[] {
    if(ctrs) {
      let sharingProjectType: SharingProjectType[] = [];
      ctrs.forEach(ct => sharingProjectType.push(this.toSharingProjectType(ct)));
      return sharingProjectType;
    } else {
      return [];
    }
  }

  static toSharingItemList(apps: SharingProjectTypeResponse[]) : Item[] {
    if(apps) {
      let sharingProjectType: Item[] = [];
      apps.forEach(ap => sharingProjectType.push(new Item(ap.sharingProjectTypeId, ap.sharingProjectTypeDescription)));
      return sharingProjectType;
    } else {
      return [];
    }
  }

  private getLanguageUrl(language: string) {
      return '?Language=' + language;
  }

  private getLanguage(language: string | null) {
    // console.log('language',language)
      return (language ? language : LanguageEnum.PT_BR);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
